<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-image
          style="width: 100%"
          src="img/about2.jpg"
          fit="contain"
        ></el-image>
      </div>

      <div class="wrap">
        <div class="header">
          <div class="header-left">
            <span v-if="language === 'ch'">关于我们</span
            ><span v-else>About US</span>
          </div>
          <div class="header-right">
            <span v-if="language === 'ch'">首页 > 关于我们 > 生产设备</span
            ><span v-else>Home > About Us > Production Equipment</span>
          </div>
        </div>
        <div class="conten-wrap">
          <div class="left">
            <router-link to="/about">
              <div class="left-item">
                <i class="el-icon-caret-right"> </i
                ><span v-if="language === 'ch'">简介</span
                ><span v-else>Introduction</span>
              </div>
            </router-link>
            <router-link to="/aboutProduct">
              <div class="left-item">
                <i class="el-icon-caret-right"> </i
                ><span v-if="language === 'ch'">生产设备</span
                ><span v-else>Production Equipment</span>
              </div>
            </router-link>
            <router-link to="/aboutDesign">
              <div class="left-item">
                <i class="el-icon-caret-right"> </i
                ><span v-if="language === 'ch'">设计和测试</span
                ><span v-else>Design and testing</span>
              </div>
            </router-link>
          </div>
          <div class="right">
            <el-image
              v-if="language === 'ch'"
              src="img/About-description1.jpg"
              fit="fill"
            ></el-image>
            <div v-else>
              <div class="item flex-row">
                <el-image class="small-img" src="img/about/auoutp1.jpg" fit="fill"></el-image>
                <el-image class="small-img" src="img/about/auoutp2.jpg" fit="fill"></el-image>
              </div>
              <div class="item flex-row">
                <el-image class="small-img" src="img/about/auoutp3.jpg" fit="fill"></el-image>
                <el-image class="small-img" src="img/about/auoutp4.jpg" fit="fill"></el-image>
              </div>

              <div class="item flex-row">
                <el-image class="small-img" src="img/about/auoutp5.jpg" fit="fill"></el-image>
                <el-image class="small-img" src="img/about/auoutp6.jpg" fit="fill"></el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      language: "",
    };
  },
  methods: {},
  created() {},
  mounted() {
    this.language = localStorage.getItem("curlanguage");
  },
};
</script>

<style scoped>
.hom-page {
  height: 100%;
  widows: 100%;
}
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: 1330px;
}
.lunbo {
  margin: 12px 0;
}
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
}
.header-left {
  border-bottom: 1px solid #cccccc;
  width: 25%;
}
.header-right {
  border-bottom: 1px solid #cccccc;
  width: 70%;
  color: #cccccc;
  display: flex;
  justify-content: flex-end;
  float: right;
  font-size: 14px;
}
.conten-wrap {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left {
  line-height: 30px;
  width: 30%;
}
.left-item {
  cursor: pointer;
}
.left-item:hover {
  color: blue;
}
.right {
  width: 70%;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.small-img {
  width: 380px;
  height: 380px;
}
.item {
  margin-bottom: 10px;
}
</style>
